// src/Dashboard/pages/user/News/components/NewsHeader.jsx

import React from "react";
import {
  FaBullhorn,
  FaNewspaper,
  FaPlus,
  FaSyncAlt,
  FaTrophy,
} from "react-icons/fa";

export default function NewsHeader({
  loading,
  isManager,
  onRefresh,
  onCreate,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-6 text-white sm:px-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
              <FaNewspaper />
              Actualités
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Actualités & résultats
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-white/90">
              Publiez les annonces du club, les résultats de compétition, les
              événements importants et les informations utiles aux adhérents.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaBullhorn />
                Annonces
              </span>

              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaTrophy />
                Résultats
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-70"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>

            {isManager && (
              <button
                type="button"
                onClick={onCreate}
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-slate-800"
              >
                <FaPlus />
                Nouvelle actu
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}